import { useJourneys } from '@/composables/useJourneys'
import api from "./newBase.api"

// Interfaces
interface JornadaConteudo {
  id: string
  midiaId: string
  cursoId: string
  formacaoId: string
  ordem: number
}

export interface AdminJourneyResponse {
  id: string
  ativo: boolean
  titulo: string
  situacao: string
  alcance: 'Manual' | 'Automatizado'
  segmentacaoId?: string
  usuariosIds?: string[]
  obrigatorio: boolean
  observacao: string
  imagemDeCapa: string
  imagemDeFundo: string
  imagemDeFundoAjuste: 'fill' | 'contain' | 'cover' | 'none' | 'scale-down'
  imagemDeFundoOpacidade: number
  jornadasConteudos: JornadaConteudo[]
  notificarViaEmail: boolean
  statusProvisionamento: 'Pendente' | 'Processando' | 'Concluido' | 'Erro'
  contextoDaIA?: string | null
}

export const adminJourney = {
  ...api,
  resource: 'jornada',
  module: 'conteudo',
  profile: 'admin',

  // Retorna os detalhes completos da Jornada identificada por {id}
  getOne(id: string) {
    return adminJourney.get<AdminJourneyResponse>(id)
  },

  // Retorna a lista completa de jornadas
  getAll() {
    return adminJourney.get<AdminJourneyResponse[]>()
  },

  // Salva uma jornada (cria ou atualiza conforme a presença do id)
  save(id?: string, data?: any) {
    // Limpa o cache para forçar recarregamento atualizado na próxima listagem
    useJourneys().clear()

    if (id) {
      return adminJourney.put<any>(id, data)
    }

    return adminJourney.post<any>('', data)
  },

  // Remove a jornada identificada por {id}
  remove(id: string) {
    return adminJourney.delete(id)
  },

  // Sincroniza os usuários da jornada
  syncUsers(id: string) {
    return adminJourney.post(`${id}/usuarios-provisionamento`)
  },

  // Upload de imagem de capa ou fundo
  imageUpload(id: string, type: 'cover' | 'background', file: File) {
    const imageType = type === 'cover' ? 'imagem-de-capa' : 'imagem-de-fundo'

    const formData = new FormData()
    formData.append('File', file)

    return adminJourney.put(`${id}/${imageType}`, formData, {}, true)
  },

  // Retorna os usuários para provisionamento
  getUsuariosProvisionamento(id: string) {
    return adminJourney.get<any[]>(`${id}/usuarios-provisionamento`)
  }
}

export const studentJourney = {
  ...api,
  resource: 'jornada',
  module: 'conteudo',
  profile: 'aluno',

  // Retorna os detalhes completos de uma jornada do aluno
  getOne(id: string) {
    return studentJourney.get(id)
  },

  getAll(params: any = {}) {
    if (!params) params = {}

    params.page = params.page || 1
    params.size = params.size || 10

    return studentJourney.get<any[]>('', params)
  },

  setStatus(id: string, status: 'Pendente' | 'EmAndamento' | 'Concluida') {
    return studentJourney.put(`${id}/status`, { status })
  }
}